export const OverlaySettingsTipsTranslation = {
    en: `
## Overlay Setup  
### OBS Setup  
1. Click the **Copy overlay link** button. 
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/1.webp "Overlay Url")
2. Open OBS and click **"+"** in the **Sources** panel.
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/2.webp "Overlay Url")
3. Select the **Browser** option.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/3.webp "Overlay Url")
4. Name it *Whatyouwish Overlay* (or any name you prefer). Make sure **"Make source visible"** is checked.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/4.webp "Overlay Url")
5. Paste the copied overlay link into the **URL** field.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/5.webp "Overlay Url")
6. Set the **Width** to **1920** and the **Height** to **1080**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/6.webp "Overlay Url")
7. Enable **"Control audio via OBS"** to have a separate audio track in the mixer.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/7.webp "Overlay Url")
8. Enable **"Shutdown source when not visible"**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/8.webp "Overlay Url")
9. Enable **"Refresh browser when scene becomes active"**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/9.webp "Overlay Url")
10. Open the **Advanced Audio Properties** of the overlay source.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/10.webp "Overlay Url")
11. In the **Audio Monitoring** section, select **Monitor and Output** for the overlay.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/en/11.webp "Overlay Url")
    `,
    uk: `
## Налаштування оверлею  
### Налаштування в OBS  
1. Натисніть кнопку **Скопіювати посилання на оверлей**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/1.webp "Overlay Url")
2. Відкрийте OBS і натисніть **"+"** у панелі **Джерела**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/2.webp "Overlay Url")
3. Оберіть параметр **Браузер**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/3.webp "Overlay Url")
4. Назвіть джерело, наприклад, *Whatyouwish Overlay* (або будь-якою іншою назвою). Переконайтеся, що увімкнено опцію **"Зробити джерело видимим"**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/4.webp "Overlay Url")
5. Вставте скопійоване посилання у поле **URL-адреса**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/5.webp "Overlay Url")
6. Встановіть **ширину** — **1920**, та **висоту** — **1080**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/6.webp "Overlay Url")
7. Увімкніть **"Керувати звуком через OBS"**, щоб мати окрему аудіодоріжку в мікшері.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/7.webp "Overlay Url")
8. Увімкніть **"Вимикати джерело, коли воно не видиме"**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/8.webp "Overlay Url")
9. Увімкніть **"Оновити браузер, коли сцена стає активною"**.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/9.webp "Overlay Url")
10. Відкрийте **Розширені властивості аудіо** для цього джерела.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/10.webp "Overlay Url")
11. У розділі **Прослуховування звуку** виберіть **Прослуховування та вивід** для оверлею.  
![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/overlay-settings/ua/11.webp "Overlay Url")
    `
}